import React from "react";
import { FormattedMessage } from "react-intl";
import { DashboardPanelEmptyState } from "../DashboardPanel/DashboardPanelEmptyState";
import { Typography } from "@material-ui/core";

export interface DashboardExpertsListEmptyProps {}

export const DashboardExpertsListEmpty = (props: DashboardExpertsListEmptyProps) => {
  
  return (
    <DashboardPanelEmptyState iconname='expert'>
      <Typography component='h3' variant='h4'>
        <FormattedMessage id='DashboardExpertsEmptyText' />
      </Typography>
    </DashboardPanelEmptyState>
  );
};